<template>
  <v-app>
    <terms-dialog
      v-if="currentUser && currentUser.term"
      :open-dialog="showTermsDialog"
      :terms="currentUser.term"
      @confirm-terms="confirmTerms"
      @update:open-dialog="showTermsDialog = $event"
    />

    <privacy-policy-dialog
      v-if="currentUser && currentUser.privacy_policy"
      :open-dialog="showPrivacyPolicyDialog"
      :privacy-policy="currentUser.privacy_policy"
      @confirm-privacy-policy="confirmPrivacyPolicy"
      @update:open-dialog="showPrivacyPolicyDialog = $event"
    />
    <loading />
    <custom-loading />
    <toolbar-nav
      v-if="needToolbar"
      v-show="!$vuetify.breakpoint.smAndDown"
    />
    <v-app-bar
      v-if="needToolbar"
      v-show="$vuetify.breakpoint.smAndDown"
    >
      {{ $t('app_name') }}
    </v-app-bar>
    <div class="main-app">
      <v-main
        id="main-app"
      >
        <v-container
          class="app-container pa-0"
          fluid
        >
          <router-view />
        </v-container>
      </v-main>
    </div>
    <related-offers-cart-dialog />
    <snackbar />
    <vordesk />
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TermsDialog from '@/components/dialogs/TermsDialog.vue';
import PrivacyPolicyDialog from '@/components/dialogs/PrivacyPolicyDialog.vue';
import RelatedOffersCartDialog from '@/components/dialogs/RelatedOffersCartDialog.vue';
import ToolbarNav from './components/navs/ToolbarNav.vue';
import Loading from './components/feedbacks/Loading.vue';
import CustomLoading from './components/feedbacks/CustomLoading.vue';
import Snackbar from './components/feedbacks/Snackbar.vue';
import Vordesk from './components/feedbacks/Vordesk.vue';

export default {
  name: 'App',
  components: {
    ToolbarNav,
    Loading,
    Snackbar,
    CustomLoading,
    Vordesk,
    TermsDialog,
    PrivacyPolicyDialog,
    RelatedOffersCartDialog,
  },

  data() {
    return {
      drawer: false,
      showTermsDialog: false,
      showPrivacyPolicyDialog: false,
    };
  },
  computed: {
    ...mapGetters([
      'hasSession',
      'getStepUser',
      'currentUser',
      'getAcceptedWithSuccess',
    ]),
    needToolbar() {
      return (this.$route.meta.needToolbar && this.hasSession);
    },
  },
  watch: {
    hasSession(hasSession) {
      if (!hasSession) {
        this.$router.push({ name: 'login' });
      }
    },
    getStepUser(value) {
      if (value === 5) {
        this.$router.push({ name: 'home' });
      }
    },
    currentUser(user) {
      if (user && this.$route.meta.requiresAuth) {
        if (!user.accepted_terms) {
          this.showTermsDialog = true;
          return;
        }

        if (!user.accepted_privacy_policy) {
          this.showPrivacyPolicyDialog = true;
        }
      }
    },
    getAcceptedWithSuccess(value) {
      if (value) {
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    },
  },

  methods: {
    ...mapActions([
      'acceptCurrentTerms',
      'acceptCurrentPrivacyPolicy',
    ]),

    confirmTerms() {
      this.showTermsDialog = false;
      this.showPrivacyPolicyDialog = false;
      this.acceptCurrentTerms({ accepted_terms: true });
    },

    confirmPrivacyPolicy() {
      this.showTermsDialog = false;
      this.showPrivacyPolicyDialog = false;
      this.acceptCurrentPrivacyPolicy({ accepted_privacy_policy: true });
    },
  },
};
</script>
<style lang="scss" scoped>
  .app-container{
    background: $app_background;
    min-height: 100%;
  }
</style>
